<div class="footer-container">
  <div class="footer-main">
    <div class="footer-section">
      <h3>{{ "FOOTER.LOCATION" | translate }}</h3>
      <p class="location-item">
        <svg class="swiss-flag" width="20" height="20" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" fill="#FF0000"/>
          <rect x="13" y="6" width="6" height="20" fill="#FFFFFF"/>
          <rect x="6" y="13" width="20" height="6" fill="#FFFFFF"/>
        </svg>
        <span>Switzerland</span>
      </p>
    </div>

    <div class="footer-section">
      <h3>{{ "FOOTER.CONTACTS" | translate }}</h3>
      <p>
        <a href="mailto:contact@applisound.com">contact&#64;applisound.com</a>
      </p>
    </div>

    <div class="footer-section">
      <h3>{{ "FOOTER.FOLLOW_US" | translate }}</h3>
      <div class="social-icons">
        <a
          href="https://www.instagram.com/applisound/"
          target="_blank"
          class="social-icon"
          title="Instagram"
        >
          <i class="fab fa-instagram"></i>
        </a>
        <a
          href="http://tiktok.com/@applisound"
          target="_blank"
          class="social-icon"
          title="TikTok"
        >
          <i class="fab fa-tiktok"></i>
        </a>
        <a
          href="https://www.youtube.com/@applisound"
          target="_blank"
          class="social-icon"
          title="YouTube"
        >
          <i class="fab fa-youtube"></i>
        </a>
        <a
          href="https://soundcloud.com/applisound"
          target="_blank"
          class="social-icon"
          title="SoundCloud"
        >
          <i class="fab fa-soundcloud"></i>
        </a>
        <a
          href="https://open.spotify.com/intl-fr/artist/0VhB2kEnVBNqwtsuJ0Fidc"
          target="_blank"
          class="social-icon"
          title="Spotify"
        >
          <i class="fab fa-spotify"></i>
        </a>
      </div>

  <app-language-selector class="language-selector" [showTitle]="true"></app-language-selector>
    </div>
  </div>

  <div class="footer-copyright">
    <p>{{ "FOOTER.COPYRIGHT" | translate : { year: currentYear } }}</p>
  </div>
</div>
